module.exports = __webpack_public_path__ + "static/media/logo.54e48ce8.png";